import { render, staticRenderFns } from "./BdInput.vue?vue&type=template&id=51b5fe19&scoped=true&"
import script from "./BdInput.vue?vue&type=script&lang=js&"
export * from "./BdInput.vue?vue&type=script&lang=js&"
import style0 from "./BdInput.vue?vue&type=style&index=0&id=51b5fe19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5fe19",
  null
  
)

export default component.exports